"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDomainEidPrefix = void 0;
exports.getExactMatchBuyEID = getExactMatchBuyEID;
var _EidCodes = require("./constants/EidCodes");
function getExactMatchBuyEID({
  isAftermarketPremium = false,
  isRegPremium = false,
  showSmartExactMatchDomain = false,
  isAuction = false,
  showMakeOffer,
  eid = '',
  eidBase = ''
}) {
  const EID_CODES = (0, _EidCodes.getEidCodes)(eidBase);
  if (eid) {
    return eid;
  } else if (isAftermarketPremium) {
    return EID_CODES.PremiumDomain.AftermarketExactMatch;
  } else if (isRegPremium) {
    return EID_CODES.PremiumDomain.RegistryExactMatch;
  } else if (showSmartExactMatchDomain) {
    return EID_CODES.SmartTld.Default;
    // There are three states of showMakeOffer flag: true/false for auction domain and undefined for non auction domain.
    // showMakeOffer === false comparison is used to be sure domain is auction and at the same time addable straight to cart.
  } else if (showMakeOffer === false) {
    return `${EID_CODES.Domain.Exact}.auction`;
  } else if (isAuction) {
    return EID_CODES.AuctionDomain.ExactMatch;
  }
  return EID_CODES.Domain.Exact;
}
const getDomainEidPrefix = ({
  isAftermarketPremiumDomain,
  isAuctionDomain,
  isRegPremiumDomain
}) => {
  switch (true) {
    case isRegPremiumDomain:
      return '.registry_premium';
    case isAuctionDomain:
      return '.auction';
    case isAftermarketPremiumDomain:
      return '.premium';
    default:
      return '';
  }
};
exports.getDomainEidPrefix = getDomainEidPrefix;